import { SessionProvider } from './SessionContext'
import { ProfileProvider } from './ProfileContext'

/**
 * Composition wrapper for the auth contexts. Nesting order matters:
 * ProfileContext calls useSession() internally, so SessionProvider must wrap
 * ProfileProvider. Mounted once at the app root in place of the former
 * single <AuthProvider>.
 */
export function AuthProviders({ children }) {
  return (
    <SessionProvider>
      <ProfileProvider>{children}</ProfileProvider>
    </SessionProvider>
  )
}
